import styled from '@emotion/styled'
import { colors, radius, spacing } from '@mobi/component-library/Foundations'

export const InnerContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
  padding: spacing.smx1,
  border: `1px solid ${colors.neutral[200]}`,
  borderRadius: radius.lgx1,
})
